import api from "../index";

export const GetLeaderboardApi = (params) => api.get(`trading/get-leader-board?${params}`);